<template>
  <div class="flex flex-col items-center py-8 px-4">
    <div class="w-full max-w-lg">

      <!-- Header -->
      <div class="mb-6">
        <h2 class="text-base font-semibold text-gray-800">Add AGM Date</h2>
        <p class="text-sm text-gray-500 mt-1">
          Assign an Annual General Meeting date to a registered company by entering
          the Business Registration Number and selecting the scheduled day and month.
        </p>
      </div>

      <!-- Card -->
      <div class="bg-white border border-gray-200 rounded-xl shadow-sm p-6">
        <form @submit.prevent="saveServiceCentre" class="space-y-4">

          <!-- BRN -->
          <div class="flex flex-col gap-1">
            <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">
              Business Registration Number
            </label>
            <input
              type="text"
              v-model="form.brn"
              placeholder="e.g. 80000012345678"
              required
              class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50"
            />
          </div>

          <!-- Day + Month -->
          <div class="grid grid-cols-2 gap-3">
            <div class="flex flex-col gap-1">
              <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Day</label>
              <select
                v-model="form.day"
                required
                class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary"
              >
                <option value="">-- Select Day --</option>
                <option v-for="option in days" :key="option.value" :value="option.value">{{ option.text }}</option>
              </select>
            </div>
            <div class="flex flex-col gap-1">
              <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Month</label>
              <select
                v-model="form.month"
                required
                class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary"
                @change="alterDay(form.month)"
              >
                <option value="">-- Select Month --</option>
                <option v-for="option in months" :key="option.value" :value="option.value">{{ option.text }}</option>
              </select>
            </div>
          </div>

          <!-- Submit -->
          <div class="border-t border-gray-100 pt-2 flex justify-end">
            <button type="submit" class="btn-primary" :disabled="loading">
              <i class="fa fa-save mr-1.5"></i>
              <span v-if="!loading">Save AGM Date</span>
              <span v-else>Saving...</span>
            </button>
          </div>

        </form>
      </div>

    </div>
  </div>
</template>

<script>
import { api } from "@/app/services/api.service.ts";

export default {
  name: "MeetingDateList",
  data() {
    return {
      loading: false,
      form: {
        brn: "",
        day: "",
        month: ""
      },
      days: [],
      months: []
    };
  },
  mounted() {
    this.initializeDayAndMonth();
  },
  methods: {
    initializeDayAndMonth() {
      this.days = Array.from({ length: 31 }, (_, i) => ({ value: i + 1, text: i + 1 }));
      this.months = [
        { value: 1, text: "January" },
        { value: 2, text: "February" },
        { value: 3, text: "March" },
        { value: 4, text: "April" },
        { value: 5, text: "May" },
        { value: 6, text: "June" },
        { value: 7, text: "July" },
        { value: 8, text: "August" },
        { value: 9, text: "September" },
        { value: 10, text: "October" },
        { value: 11, text: "November" },
        { value: 12, text: "December" }
      ];
    },
    alterDay(month) {
      month = Number(month);
      if (month) {
        const monthWith30Days = [4, 6, 9, 11];
        if (month === 2) {
          this.days = Array.from({ length: 29 }, (_, i) => ({ value: i + 1, text: i + 1 }));
          if (this.form.day > 29) this.form.day = 29;
        } else if (monthWith30Days.includes(month)) {
          this.days = Array.from({ length: 30 }, (_, i) => ({ value: i + 1, text: i + 1 }));
          if (this.form.day > 30) this.form.day = 30;
        } else {
          this.days = Array.from({ length: 31 }, (_, i) => ({ value: i + 1, text: i + 1 }));
        }
      }
    },
    resetForm() {
      this.form = { brn: "", day: "", month: "" };
    },
    async saveServiceCentre() {
      this.loading = true;
      try {
        const response = await api().post("/incorporation/backoffice-edits/add-agm-to-company", this.form);
        if (response) {
          this.successToast("Success", response.data.data);
          this.resetForm();
        }
      } catch (error) {
        if (error) {
          this.errorToast("Error", error.response.data.message);
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
